import gsap from "gsap";

export default class Utils {
    static getPayLinesPositions(tables) {
        return tables.map(rows => {
            const positions = [];

            for (let row = 0; row < rows.length; row++) {
                for (let column = 0; column < rows[row].length; column++) {
                    if (rows[row][column]) {
                        positions.push({ row, column });
                    }
                }
            }

            return positions;
        });
    }

    static randomBoolean() {
        return Math.random() > 0.5;
    }

    static randomInteger(min, max) {
        const rand = min - 0.5 + Math.random() * (max - min + 1);
        return Math.round(rand);
    }

    static shuffleArray(array) {
        return array
            .map(value => ({ value, sort: Math.random() }))
            .sort((a, b) => a.sort - b.sort)
            .map(({ value }) => value);
    }

    static formatCoinText(coins) {
        let result = null;

        if (coins >= 10000) {
            result = coins.toString().slice(0, 2) + "K";
        } else {
            result = coins.toString();
        }

        return result;
    }

    static fitTextWidth(text, maxWidth) {
        text.scale.set(1);
        if (text.width > maxWidth) {
            text.scale.set(maxWidth / text.width);
        }
    }

    static toClientUTC(serverUTC) {
        const regex = /(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d):(\d\d):(\d\d)/;
        const arrMatch = serverUTC.match(regex);

        return Date.UTC(
            arrMatch[1],
            arrMatch[2] - 1,
            arrMatch[3],
            arrMatch[4],
            arrMatch[5],
            arrMatch[6],
        );
    }

    static findTimeScale(speedMult) {
        return 1 + speedMult / 75;
    }

    static tryParse(value) {
        if (typeof value === "string") {
            value = parseFloat(value.replace(",", ""));
        }

        return value;
    }
}

export function asyncDelay(delay) {
    return new Promise(r => gsap.delayedCall(delay, r));
}

export function delayedAsyncAction(delay, callback) {
    let cancel;

    const promise = new Promise((resolve, reject) => {
        const tween = gsap.delayedCall(delay, () => {
            callback();
            resolve();
        });

        cancel = () => {
            tween.kill();
            resolve();
        };
    });

    promise.cancel = cancel;

    return promise;
}

export function reelsToRows(reels) {
    const rows = [];

    for (let i = 0; i < reels.length; i++) {
        const row = [];

        for (let j = 0; j < reels[i].length; j++) {
            const symbol = reels[i][j];

            if (!rows[j]) {
                rows[j] = [];
            }

            rows[j][i] = symbol;
        }
    }

    return rows;
}
